/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const CircleAlert = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 20 20">
      <g>
        <path d="M10,19.5 C4.75329488,19.5 0.5,15.2467051 0.5,10 C0.5,4.75329488 4.75329488,0.5 10,0.5 C15.2467051,0.5 19.5,4.75329488 19.5,10 C19.4944883,15.2444204 15.2444204,19.4944883 10,19.5 L10,19.5 Z M10,1.5 C5.30557963,1.5 1.5,5.30557963 1.5,10 C1.5,14.6944204 5.30557963,18.5 10,18.5 C14.6944204,18.5 18.5,14.6944204 18.5,10 C18.4944896,5.30786402 14.692136,1.50551044 10,1.5 Z" />
        <path d="M10 11.5C9.72385763 11.5 9.5 11.2761424 9.5 11L9.5 6C9.5 5.72385763 9.72385763 5.5 10 5.5 10.2761424 5.5 10.5 5.72385763 10.5 6L10.5 11C10.5 11.2761424 10.2761424 11.5 10 11.5zM10 14.5C9.72385763 14.5 9.5 14.2761424 9.5 14L9.5 13C9.5 12.7238576 9.72385763 12.5 10 12.5 10.2761424 12.5 10.5 12.7238576 10.5 13L10.5 14C10.5 14.2761424 10.2761424 14.5 10 14.5z" />
      </g>
    </BaseSvgIcon>
  )
}

export default CircleAlert
